"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { Button, Table, TableBody, TableCell, TableRow, CardContent, Card } from "@saridana-core/react-ui-kit";
import { TDownloadFilesSection } from "@shared/types";
import { SectionHeading } from "@shared/ui";
import Image from "next/image";
import Link from "next/link";
export function DownloadFilesSection(t0) {
  const $ = _c(9);
  const {
    title,
    description,
    items,
    itemsTitle
  } = t0;
  let t1;
  if ($[0] !== description || $[1] !== title) {
    t1 = <div className="lg:w-[45%] lg:min-w-[45%] space-y-[60px]"><SectionHeading title={title} description={description} titleClassName="text-left mx-0 lg:mx-auto leading-[115%]" descriptionClassName="text-grey-700 text-left leading-[134%]" /></div>;
    $[0] = description;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== items || $[4] !== itemsTitle) {
    t2 = items && items.length > 0 && <div className="flex-1 mt-0 lg:mt-4">{itemsTitle && <div className="text-gray-700 text-lg lg:text-xl tracking-widest font-bold mb-5">{itemsTitle}</div>}{items.map(_temp)}</div>;
    $[3] = items;
    $[4] = itemsTitle;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <section className="py-[80px] sm:py-[100px] relative overflow-hidden bg-white"><div className="container relative"><div className="flex gap-10 xl:gap-[100px] w-full flex-col lg:flex-row">{t1}{t2}</div></div></section>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp(item, index) {
  return <Card key={item.fileName + "-" + index} className="mb-4 shadow-none overflow-hidden"><CardContent className="flex items-center justify-between space-x-6 py-3 px-4"><div className="flex-1 flex items-center gap-3">{item.icon && item.icon.data && <Image src={item.icon?.data?.attributes?.url || ""} width={item.icon?.data?.attributes?.width || 24} height={item.icon?.data?.attributes?.height || 24} alt={item.icon?.data?.attributes?.alternativeText || item.icon?.data?.attributes?.name} className="size-6 min-w-6" />}<span className="flex-1">{item.fileName}</span></div><Button variant="link" asChild={true}><Link href={item.file?.data?.attributes?.url} target="_blank"><ArrowDownTrayIcon className="size-6" /><span className="hidden md:block">{item.buttonText}</span></Link></Button></CardContent></Card>;
}